import { useNavigate, useParams } from 'react-router-dom'
import { Button, Popover, Typography, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'

import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'
import { ETranslationNs } from 'src/types'
import { useState, MouseEvent } from 'react'

import useStyles from './styles'

interface IProps {
  isOpen?: boolean
  disabled?: boolean
}

const ScanToEarnButton = ({ isOpen = true, disabled = false }: IProps) => {
  const [t] = useTranslation(ETranslationNs.Navbar)
  const { accountId } = useParams()
  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const classes = useStyles({})

  const handleClick = () => navigate(joinAbsRoute(ROUTES.USER, ROUTES.SCAN_TO_EARN))

  const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Button
        disabled={disabled}
        variant="contained"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={handleClick}
        sx={{
          display: 'inline-flex',
          my: '12px',
          height: isOpen ? '45px' : '28px',
          width: isOpen ? '45px' : '28px',
          minWidth: '24px',
          borderRadius: '50%',
          padding: 0,
        }}
      >
        <AddAPhotoIcon sx={{ width: isOpen ? '28px' : '18px', height: isOpen ? '28px' : '18px' }} />
      </Button>

      <Popover
        sx={{ pointerEvents: 'none', marginLeft: '12px' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        disableScrollLock
      >
        <div className={classes.textWrapper}>
          <Typography className={classes.title}>{t('scan-to-earn-header-title.v')}</Typography>
        </div>
      </Popover>
    </Box>
  )
}

export { ScanToEarnButton }
